<template>
  <div>
    <v-card>
        <v-card-title>
          <span class="headline">Comprobante</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-layout wrap>
                <v-flex xs12 sm6 lg4 d-flex>
                  <v-select
                    :items="tiposDocumentos"
                    item-text="value"
                    item-value="id"
                    label="Documento de identidad"
                    v-model="registro.comprobanteTipoDocumento"
                    v-bind:readonly="disabledRegistro"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm5 lg3 d-flex>
                    <v-text-field label="Número documento" mask="###########" v-model="registro.comprobanteNumeroDocumento" v-bind:readonly="disabledRegistro" v-on:keyup="consultarDni()"></v-text-field>
                </v-flex>
                <v-flex xs12 sm5 lg3 d-flex>
                    <v-btn color="primary" dark class="mb-2" v-if="!disabledRegistro && seleccionarClienteActivo" @click="buscarCliente()">Buscar cliente</v-btn>
                </v-flex>
              </v-layout>
              <v-layout justify-end wrap>
                <v-flex xs8 sm3 lg3 d-flex>
                  <v-menu
                    ref="menu"
                    :close-on-content-click="false"
                    v-model="menu"
                    :nudge-right="40"
                    :return-value.sync="registro.comprobanteFecha"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                  >
                    <v-text-field
                      slot="activator"
                      v-model="comprobanteFecha"
                      label="Fecha"
                      prepend-icon="event"
                      @blur="registro.comprobanteFecha = parseDate(comprobanteFecha)"
                      :messages="errores.comprobanteFecha.mensajes"
                      :error="errores.comprobanteFecha.error"
                      readonly
                    ></v-text-field>
                    <v-date-picker v-model="registro.comprobanteFecha" locale='es-pe' @input="$refs.menu.save(registro.comprobanteFecha)" scrollable v-bind:readonly="disabledRegistro"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs4 sm2 lg2>
                    <v-text-field label="Hora" mask="time" v-model="registro.comprobanteHora" :messages="errores.comprobanteHora.mensajes" :error="errores.comprobanteHora.error" v-bind:readonly="disabledRegistro"></v-text-field>
                </v-flex>
              </v-layout>
              <v-flex xs12 sm12>
                <v-text-field label="Cliente" v-model="registro.comprobanteCliente" maxlenght=50 :messages="errores.comprobanteCliente.mensajes" :error="errores.comprobanteCliente.error" v-bind:readonly="disabledRegistro" v-on:keyup="registro.comprobanteCliente = registro.comprobanteCliente.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex xs12 sm8 lg10 d-flex>
                <v-text-field label="Dirección" v-model="registro.comprobanteDireccion" maxlenght=50 v-bind:readonly="disabledRegistro" v-on:keyup="registro.comprobanteDireccion = registro.comprobanteDireccion.toUpperCase();"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 lg2 d-flex>
                  <v-autocomplete
                      :loading="loading"
                      :items="ubigeo"
                      item-text="nombre"
                      item-value="id"
                      v-model="registro.comprobanteUbigeo"
                      hide-no-data
                      hide-details
                      label="Ubigeo"
                      v-bind:readonly="disabledRegistro"
                    ></v-autocomplete>
                </v-flex>
              <v-flex xs8 sm5 lg2 d-flex>
                <v-select
                  v-bind:readonly="disabledRegistro"
                  :items="seriesCombo"
                  item-text="value"
                  item-value="id"
                  label="Serie"
                  v-model="registro.comprobanteSerie"
                ></v-select>
              </v-flex>
              <v-flex xs4 sm3 lg1 d-flex>
                <v-text-field label="Número" mask="#######" v-model="registro.comprobanteNumero" :messages="errores.comprobanteNumero.mensajes" :error="errores.comprobanteNumero.error" v-bind:readonly="disabledRegistro"></v-text-field>
              </v-flex>
              <v-flex xs12 sm4 lg6 d-flex>
              </v-flex>
              <v-flex xs8 sm5 lg2 d-flex>
                <v-text-field label="Serie guía" v-model="registro.guiaSerie" :messages="errores.guiaSerie.mensajes" :error="errores.guiaSerie.error" v-bind:readonly="disabledRegistro"></v-text-field>
              </v-flex>
              <v-flex xs4 sm3 lg1 d-flex>
                <v-text-field label="Número guía" mask="#######" v-model="registro.guiaNumero" :messages="errores.guiaNumero.mensajes" :error="errores.guiaNumero.error" v-bind:readonly="disabledRegistro"></v-text-field>
              </v-flex>
              <v-flex xs12 sm2 lg1 d-flex>
                <v-btn color="primary" dark class="mb-2" v-if="!disabledRegistro" @click="importarGuia()">Importar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm12 d-flex v-for="(detalle, id) in registro.comprobanteDetalles" v-bind:key="id">
                  <v-flex xs3 sm2 d-flex>
                    <v-autocomplete
                      :loading="loading"
                      :items="productosCodigos"
                      item-text="nombre"
                      item-value="id"
                      v-model="detalle.producto"
                      v-on:change="escogerProducto(detalle)"
                      hide-no-data
                      hide-details
                      label="Código de producto"
                      v-bind:readonly="disabledRegistro"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs1 sm1 d-flex>
                    <v-text-field label="Cantidad" @change="sumarTotal" v-model="detalle.cantidad" v-bind:readonly="disabledRegistro"></v-text-field>
                  </v-flex>
                  <v-flex xs1 sm1 d-flex>
                    <v-text-field label="Unidad" v-model="detalle.unidadMedida" v-bind:readonly="disabledRegistro"></v-text-field>
                  </v-flex>
                  <v-flex xs3 sm6 d-flex>
                    <v-text-field label="Detalle" v-model="detalle.descripcion" v-bind:readonly="disabledRegistro" v-on:keyup="detalle.descripcion = detalle.descripcion.toUpperCase();"></v-text-field>
                  </v-flex>
                  <v-flex xs2 sm1 d-flex>
                    <v-text-field label="P. Unit." @change="sumarTotal" v-model="detalle.totalUnitario" v-bind:readonly="disabledRegistro" v-money></v-text-field>
                  </v-flex>
                  <v-flex xs2 sm1 d-flex>
                    <v-text-field label="Total" @change="sumarTotal" v-model="detalle.total" v-bind:readonly="disabledRegistro" v-money></v-text-field>
                  </v-flex>
                </v-flex>
              </v-layout>
              <v-btn @click="detalleNuevo"
              absolute
              dark
              fab
              bottom
              right
              small
              v-if="!disabledRegistro"
              color="pink"
              >
                <v-icon>add</v-icon>
              </v-btn>
            </v-container>
            <!-- <venta-seleccionar-producto v-bind:productos="productosDetalle" v-bind:disabled = "disabledRegistro" v-on:total-seleccion = "setTotal"></venta-seleccionar-producto> -->
          </v-card>
          <br />
          <v-layout justify-end wrap>
            <v-flex xs3 sm3>
              <v-checkbox v-model="registro.bienesAmazonia" v-bind:readonly="disabledRegistro" :label="`Bienes transferidos en la amazonía`"></v-checkbox>
              <v-checkbox v-model="registro.serviciosAmazonia" v-bind:readonly="disabledRegistro" :label="`Servicios prestados en la amazonía`"></v-checkbox>
            </v-flex>
            <v-flex xs2 sm2>
              <v-text-field label="Total" v-model="registro.comprobanteTotal" maxlenght=20 :messages="errores.comprobanteTotal.mensajes" :error="errores.comprobanteTotal.error" v-money readonly></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div v-if="disabledRegistro && registro.comprobanteEstado === '' && diasEmision > 7" style="color: red; margin-right: 20px;"><b>Fecha de emisión superior a 7 días, puede ser rechazada por SUNAT</b></div>
          <v-btn :color="colorEmitir" dark @click.native="emitir(registro.comprobanteId)" v-if="disabledRegistro && registro.comprobanteEstado === ''">Emitir</v-btn>
          <v-btn color="primary" dark @click.native="editar(registro.comprobanteId)" v-if="disabledRegistro && registro.comprobanteEstado === ''">Editar</v-btn>
          <v-btn color="success" dark @click.native="guardar(registro.comprobanteId)" v-if="!disabledRegistro">Guardar</v-btn>
          <v-btn color="primary" dark @click.native="imprimirRegistro({fila: [registro.comprobanteId]})" v-if="disabledRegistro && !anularRegistro && registro.comprobanteEstado !== ''">Imprimir</v-btn>
          <v-btn color="error" dark @click.native="confirmarAnular(registro.comprobanteId)" v-if="disabledRegistro && !anularRegistro && puedeAnular">Anular</v-btn>
          <v-btn color="primary" dark @click.native="cerrar">Cerrar comprobante</v-btn>
          <v-btn color="error" dark @click.native="anular(registro.comprobanteId)" v-if="disabledRegistro && anularRegistro && puedeAnular">Confirmar anular</v-btn>
        </v-card-actions>
      </v-card>
      <v-dialog v-model="ventanaCliente" max-width="80%">
        <v-card>
          <clientes-lista :seleccionar="true" @seleccionado="seleccionarCliente"></clientes-lista>
        </v-card>
      </v-dialog>
  </div>
</template>

<script>
import mixin from '../mixins.js'
import pdfMake from 'pdfmake/build/pdfmake.js'
import pdfFonts from 'pdfmake/build/vfs_fonts.js'
import moment from 'moment'

export default {
  mixins: [mixin],
  name: 'comprobante',
  props: {
    idRegistro: 0,
    ubigeo: {},
    idCliente: 0
  },
  data: () => ({
    disabledRegistro: false,
    anularRegistro: false,
    loading: false,
    datos: [],
    tiposDocumentos: [
      { id: '-', value: '' },
      { id: '1', value: 'DNI' },
      { id: '6', value: 'RUC' },
      { id: '4', value: 'Carnet de extranjería' },
      { id: '7', value: 'Pasaporte' }
    ],
    registro: {},
    errores: {
      'comprobanteCliente': {mensajes: [], error: false},
      'comprobanteFecha': {mensajes: [], error: false},
      'comprobanteHora': {mensajes: [], error: false},
      'comprobanteNumero': {mensajes: [], error: false},
      'comprobanteSerie': {mensajes: [], error: false},
      'comprobanteTotal': {mensajes: [], error: false},
      'guiaSerie': {mensajes: [], error: false},
      'guiaNumero': {mensajes: [], error: false}
    },
    menu: false,
    productos: {},
    productosCodigos: {},
    productosDetalle: {},
    comprobanteFecha: null,
    series: {},
    seriesCombo: [],
    ventanaCliente: false,
    seleccionarClienteActivo: true
  }),
  created () {
    this.initialize()
  },
  computed: {
    computedComprobanteFecha () {
      return this.formatoFecha(this.registro.comprobanteFecha)
    },
    puedeAnular () {
      if (this.registro.comprobanteEstado === '') return false
      if (this.registro.comprobanteEstado === '2') return false
      if (this.registro.comprobanteEstado === '3') return false
      if (this.registro.comprobanteEstado === '4') return false
      var hoy = moment()
      if (hoy.diff(moment(this.registro.comprobanteFecha), 'days') > 7) return false
      return true
    },
    diasEmision () {
      const hoy = new Date()
      const emision = new Date(this.registro.comprobanteFecha)
      const diffTime = Math.abs(hoy - emision)
      const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24))
      return diffDays
    },
    colorEmitir () {
      if (this.diasEmision > 7) return 'error'
      return 'success'
    }
  },
  watch: {
    idRegistro () {
      if (this.idRegistro !== '') {
        this.ver({id: this.idRegistro})
      }
    },
    ventanaRegistroCliente () {
      if (this.ventanaRegistroCliente === false) {
        this.idClienteActual = ''
      }
    },
    'registro.comprobanteFecha' (val) {
      this.comprobanteFecha = this.formatoFecha(this.registro.comprobanteFecha)
    },
    'registro.comprobanteSerie' (val) {
      if (!this.disabledRegistro) {
        this.registro.comprobanteNumero = this.series[this.registro.comprobanteSerie].ultimo
      }
    }
  },
  methods: {
    initialize () {
      this.datos = {}
    },
    ver (item) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = {idCliente: this.idCliente}
      const myRequest = new Request(`${process.env.NODE_API}comprobante/ver/id/` + item.id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            this.anularRegistro = false
            this.registro = datos.d.comprobante
            this.seleccionarClienteActivo = false
            if (datos.d.comprobante.comprobanteUbigeo === '') {
              this.seleccionarClienteActivo = true
            }
            this.series = datos.d.series
            this.seriesCombo = []
            var tipoComprobante = '01'
            if (item.id > 0) {
              tipoComprobante = this.series[this.registro.comprobanteSerie].tipo_comprobante
            }
            for (var serie in this.series) {
              if (tipoComprobante === this.series[serie].tipo_comprobante || ((tipoComprobante === '01' || tipoComprobante === '03') && (this.series[serie].tipo_comprobante === '01' || this.series[serie].tipo_comprobante === '03'))) {
                this.seriesCombo.push({id: this.series[serie].id, value: this.series[serie].value})
              }
            }
            this.productosCodigos = []
            this.productos = datos.d.productos
            for (var producto in this.productos) {
              this.productosCodigos.push({id: producto, nombre: this.productos[producto].codigo + ' - ' + this.productos[producto].nombre + ' (' + this.productos[producto].unidadMedida + ')'})
            }
            this.errores = datos.d.errores
            if (item.id === 0) {
              this.registro.comprobanteId = 0
              this.disabledRegistro = false
            } else {
              this.disabledRegistro = true
            }
          }
        })
    },
    guardar (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}comprobante/guardar/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.ver(datos.d)
              this.$emit('listar')
            } else {
              this.errores = datos.d.errores
            }
          }
        })
    },
    emitir (id) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}comprobante/emitir/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.ver(datos.d)
              this.$emit('listar')
            } else {
              alert(datos.m[0])
            }
          }
        })
    },
    editar () {
      this.disabledRegistro = false
    },
    confirmarAnular () {
      this.anularRegistro = true
    },
    cerrar () {
      this.$emit('cerrar')
    },
    detalleNuevo () {
      var id = 0
      while (id in this.registro.comprobanteDetalles) {
        id++
      }
      this.registro.comprobanteDetalles[id] = {id: 0, cantidad: 1, producto: '', descripcion: '', unidadMedida: '', total: '0.00', totalUnitario: '0.00'}
      this.$forceUpdate()
    },
    sumarTotal: function () {
      var total = 0.0
      for (var detalle in this.registro.comprobanteDetalles) {
        this.registro.comprobanteDetalles[detalle].total = parseFloat(this.registro.comprobanteDetalles[detalle].totalUnitario * this.registro.comprobanteDetalles[detalle].cantidad).toFixed(2)
        total += parseFloat(this.registro.comprobanteDetalles[detalle].total)
      }
      this.registro.comprobanteTotal = total.toFixed(2)
    },
    setTotal: function (total) {
      this.registro.comprobanteTotal = total.toFixed(2)
    },
    escogerProducto: function (item) {
      if (!this.disabledRegistro) {
        item.cantidad = 1
        item.descripcion = this.productos[item.producto].nombre
        item.unidadMedida = this.productos[item.producto].unidadMedida
        item.totalUnitario = this.productos[item.producto].precio
        item.total = this.productos[item.producto].precio
        this.sumarTotal()
      }
    },
    buscarCliente () {
      this.ventanaCliente = true
    },
    seleccionarCliente (item) {
      this.registro.comprobanteClienteId = item.fila[0]
      this.registro.comprobanteCliente = item.fila[1]
      this.registro.comprobanteDireccion = item.fila[2]
      this.registro.comprobanteTipoDocumento = item.fila[6]
      this.registro.comprobanteNumeroDocumento = item.fila[4]
      this.registro.comprobanteUbigeo = item.fila[5]
      this.consultarLeyAmazonia(item.fila[5])
      this.ventanaCliente = false
    },
    anular (id) {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}comprobante/anular/id/` + id, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.$emit('listar')
              this.cerrar()
            } else {
              alert(datos.m[0])
            }
          }
        })
    },
    consultarLeyAmazonia (ubigeo) {
      var solicitudApi = this.crearSolicitud()
      solicitudApi.datos = this.registro
      const myRequest = new Request(`${process.env.NODE_API}comprobante/leyAmazonia/ubigeo/` + ubigeo, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro.bienesAmazonia = datos.d.bienesAmazonia
              this.registro.serviciosAmazonia = datos.d.serviciosAmazonia
            } else {
              alert(datos.m[0])
            }
          }
        })
    },
    consultarDni () {
      if (this.registro.comprobanteTipoDocumento !== '1' || this.registro.comprobanteClienteId !== undefined || this.registro.comprobanteNumeroDocumento.length !== 8) {
        return
      }
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}cliente/datosDni/` + this.registro.comprobanteNumeroDocumento, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else {
            if (datos.e === 1) {
              this.registro.comprobanteCliente = datos.d.data.primerApellido + ' ' + datos.d.data.segundoApellido + ', ' + datos.d.data.nombres
            } else {
              this.registro.comprobanteCliente = ''
            }
          }
        })
    },
    importarGuia () {
      if (!this.registro.guiaSerie || !this.registro.guiaNumero) {
        alert('Debe ingresar la serie y número de guía')
        return
      }
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}guia/ver/serie/${this.registro.guiaSerie}/numero/${this.registro.guiaNumero}`, {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(datos => {
          if (datos.l === false) {
            this.$emit('login', datos.m)
          } else if (datos.e === 1) {
            // Importar datos de la guía al comprobante
            const guia = datos.d.comprobante
            this.registro.comprobanteClienteId = guia.comprobanteClienteId
            this.registro.comprobanteCliente = guia.comprobanteCliente
            this.registro.comprobanteDireccion = guia.comprobanteDireccion
            this.registro.comprobanteTipoDocumento = guia.comprobanteTipoDocumento
            this.registro.comprobanteNumeroDocumento = guia.comprobanteNumeroDocumento
            this.registro.comprobanteUbigeo = guia.comprobanteUbigeo

            // Importar detalles de productos
            this.registro.comprobanteDetalles = {}
            for (let id in guia.comprobanteDetalles) {
              const detalleGuia = guia.comprobanteDetalles[id]
              this.registro.comprobanteDetalles[id] = {
                id: 0,
                cantidad: detalleGuia.cantidad,
                producto: detalleGuia.producto,
                descripcion: detalleGuia.descripcion,
                unidadMedida: detalleGuia.unidadMedida,
                total: '0.00',
                totalUnitario: this.productos[detalleGuia.producto] ? this.productos[detalleGuia.producto].precio : '0.00'
              }
            }
            this.sumarTotal()
            this.consultarLeyAmazonia(guia.comprobanteUbigeo)
          } else {
            alert('No se encontró la guía de remisión')
          }
        })
    },
    imprimirRegistro (item) {
      var solicitudApi = this.crearSolicitud()
      const myRequest = new Request(`${process.env.NODE_API}comprobante/imprimir/id/` + item.fila[0], {method: 'POST', body: `d=${JSON.stringify(solicitudApi)}`, headers: new Headers({'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'})})
      return fetch(
        myRequest
      )
        .then(response => response.json())
        .then(dd => {
          if (dd.content !== undefined) {
            var win = window.open('', '_blank')
            pdfMake.vfs = pdfFonts.pdfMake.vfs
            pdfMake.createPdf(dd).open({}, win)
          }
        })
    }
  }
}
</script>

<style>
.v-btn--floating .v-icon {
    height: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/Comprobante.vue